import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import GlobalLeaders from 'public/assets/global-marketing-leaders/global-leaders.png'
import IndianLeaders from 'public/assets/global-marketing-leaders/indian-leaders.png'
import AllLeaders from 'public/assets/global-marketing-leaders/all-leaders.png'
import { ReactComponent as ArrowLeft } from 'public/assets/global-marketing-leaders/icons/chevron.svg'
import { ReactComponent as TextDecoration } from 'public/assets/influencer/icons/text-decoration.svg'

const list = [
  {
    title: 'Global Marketing Leaders',
    slug: '/global-marketing-leaders/leader/global/',
    image: GlobalLeaders
  },
  {
    title: 'Indian Marketing Leaders',
    slug: '/global-marketing-leaders/leader/indian/',
    image: IndianLeaders
  },
  {
    title: 'All Marketing Leaders',
    slug: '/global-marketing-leaders/leader',
    image: AllLeaders
  }
]

function CMLCategory(): JSX.Element {
  return (
    <section className="container | py-10 lg:py-16">
      <div className="mb-20">
        <h2 className="text-3xl md:text-5xl text-center font-medium | mb-2 md:mb-6">
          Meet the marketing mavericks
        </h2>
        <TextDecoration
          className="text-[#8FEFBC] | max-w-sm | mx-auto"
          aria-hidden
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {list.map(item => (
          <Link
            key={item.title}
            href={item.slug}
            className="group | rounded-xl | max-w-xl | mx-auto | hover:outline-4 hover:outline-yellow-30 hover:outline hover:shadow-2 | transition-all"
            style={{
              background:
                'linear-gradient(159.93deg, #F52DD5 -25.93%, #5B6CFF 52.96%)'
            }}
          >
            <div className="flex justify-between gap-7 | pt-8 px-8 mb-3">
              <h3
                className="text-xl md:text-3xl font-medium"
                dangerouslySetInnerHTML={{
                  __html: item.title.split(' ').join('<br/>')
                }}
              />
              <div className="bg-white/30 | rounded-full | shrink-0 flex items-center justify-center | w-10 h-10 md:w-14 md:h-14 | group-hover:bg-yellow-40 | transition-colors">
                <ArrowLeft
                  viewBox="0 0 26 25"
                  className="text-white group-hover:text-purple-40 | w-4 h-4 md:w-6 md:h-6  | transition-colors"
                />
              </div>
            </div>

            <Image
              src={item.image.src}
              alt={item.title}
              width={item.image.width}
              height={item.image.height}
              className="saturate-0 group-hover:saturate-100 | rounded-b-xl"
            />
          </Link>
        ))}
      </div>
    </section>
  )
}

export default CMLCategory
